import contentTopHeader from "@/components/contentTopHeader";

export default {
  props: {
    name: String,
    tabActivePill: Boolean,
  },
  components: {
    contentTopHeader,
  },
  data() {
    return {
      activeTab: "",
      tabs: [
        {
          id: "upload",
          title: "Upload",
          pathName: "UploadAlbum",
        },
        {
          id: "manage",
          title: "Manage",
          pathName: "ManageIndex",
        },
      ],
    };
  },

  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  methods: {
    isActiveTab(tab) {
      return this.name === tab;
    },
    isActiveInnerTab(tab) {
      return this.activeInnerTab === tab;
    },
    setTab(pathName) {
      this.$router.push({ name: pathName });
    },
  },

  async created() {
    this.activeTab = this.name;
  },
};



// WEBPACK FOOTER //
// ./src/views/album/components/nav.ctrl.js